import { PlatePair } from '@paragon/contract-library';

const defaultYThreshold = 12;

/**
 * Supplies the y on which to switch putting plate pair labels on one or the other side of the plates.
 */
export function calculatePlatePairLabelPositioningYThreshold(platePairs: readonly PlatePair[]) {
  if (platePairs.length === 0) return defaultYThreshold;
  const minY = Math.min(...platePairs.map((platePair) => platePair.centerY));
  const maxY = Math.max(...platePairs.map((platePair) => platePair.centerY));
  const verticalMidpoint = (maxY + minY) / 2;
  return Math.min(defaultYThreshold, verticalMidpoint);
}
